export class SunEditorCustomOptions {
    languageCode: string;
    fullScreenAllowed: boolean;
    insertHabilLinkAllowed: boolean;

    constructor(languageCode: string, fullScreenAllowed: boolean, insertHabilLinkAllowed: boolean) {
        this.languageCode = languageCode;
        this.fullScreenAllowed = fullScreenAllowed;
        this.insertHabilLinkAllowed = insertHabilLinkAllowed;
    }
}